export enum PersonalityAssessmentType {
  Enneagram = 0,
  MyersBriggs = 1,
  BigFive = 2,
  DISC = 3,
  SpiritualGifts = 4,
  SpiritualPreferences = 5,
}
